import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../lib/authLib";
import { useSnackbar } from "../contexts/SnackbarContext";

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const location = useLocation();
  const { user, isAdmin, loading } = useAuthContext();
  const { showSnackbar } = useSnackbar();

  React.useEffect(() => {
    if (!loading && user && !isAdmin) {
      showSnackbar("You do not have permission to access this page", "error");
    }
  }, [loading, user, isAdmin, showSnackbar]);

  if (loading) {
    return (
      <div
        style={{
          backgroundColor: "#111827",
          color: "#ffffff",
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/login?redirectTo=${location.pathname}`} />;
  }

  if (!isAdmin) {
    return <Navigate to="/home" />;
  }

  return <>{children}</>;
};

export default AdminRoute;
